const stripeDashboardURL = process.env.NODE_ENV === "development" ? `https://dashboard.stripe.com/test` : `https://dashboard.stripe.com`;

const generateProductUrl = productType => `https://keepwhat-cdn.s3.eu-west-2.amazonaws.com/img/all-products/${productType}.svg`;

const getProductDetailsByProductType = (products, productType) => {
  if (!Array.isArray(products)) return null;
  return products.find(product => product.type === productType);
};

const getImageUrl = imagePath => {
  if (!imagePath) return "";
  const basePath = process.env.REACT_APP_IMAGES_PATH || "https://cdn-dev.keepwhat.com";

  // If the path starts with http:// or https://, extract the path portion
  if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
    try {
      const url = new URL(imagePath);
      return `${basePath}${url.pathname}`;
    } catch (e) {
      // If URL parsing fails, fall back to treating it as a regular path
      const pathOnly = imagePath.replace(/^https?:\/\/[^/]+/, "");
      return `${basePath}${pathOnly.startsWith("/") ? pathOnly : `/${pathOnly}`}`;
    }
  }

  // Otherwise, prepend the base images path
  return `${basePath}${imagePath.startsWith("/") ? imagePath : `/${imagePath}`}`;
};

export { stripeDashboardURL, generateProductUrl, getProductDetailsByProductType, getImageUrl };
